import type { Ref } from "vue";
import { BestfitOverviewReadyEvent } from '@studyportals/bestfit-overview-interfaces';
import { WishlistServiceReadyEvent } from '@studyportals/student-interfaces';
import { ProfileQuestionnairesReadyEvent } from '@studyportals/profile-questionnaires-interfaces';

export const EVENT_TYPES = {
	BestfitOverviewReady: BestfitOverviewReadyEvent.EventType,
	WishlistServiceReady: WishlistServiceReadyEvent.EventType,
	ProfileQuestionnairesReady: ProfileQuestionnairesReadyEvent.EventType,
} as const;

export type SupportedEventType = typeof EVENT_TYPES[keyof typeof EVENT_TYPES];

export interface UseEventAggregationOptions {
	waitFor: SupportedEventType[];
	waitForAll?: boolean;
	onReady?: () => void;
	onEvent?: (eventType: SupportedEventType) => void;
}

export interface UseEventAggregationReturn {
	isReady: Ref<boolean>;
	receivedEvents: Ref<Set<SupportedEventType>>;
}
